/** @format */

import React, { Fragment, useEffect, useState, useRef } from 'react';
import colors from '../assets/colors';
import { generate, mothSilky } from '../assets/random';
import baseSrc from '../images/butterflysilky-base.png';
import baseShadeSrc from '../images/butterflysilky-base-shade.png';
import underbellySrc from '../images/butterflysilky-underbelly.png';
import underbellyShadeSrc from '../images/butterflysilky-underbelly-shade.png';
import lineSrc from '../images/butterflysilky-line.png';

const Canvas = (props) => {
	const { setClick, click } = props;

	const [mainColor, setMainColor] = useState(null);
	const [markingColor, setMarkingColor] = useState(null);
	const [refresh, setRefresh] = useState(false)

	const canvasRef = useRef(null);
	const canvasRef2 = useRef(null);

	useEffect(() => {
		if (props.click) {
			props.setClick(false)
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		const canvas2 = canvasRef2.current;
		const ctx2 = canvas2.getContext('2d');

		ctx2.setTransform(1, 0, 0, 1, 0, 0);
		ctx2.clearRect(0, 0, 564, 502);
		ctx.setTransform(1, 0, 0, 1, 0, 0);
		ctx.clearRect(0, 0, 564, 502);
		drawImages(ctx, ctx2);
		}

	}, [props.click]);

	function loadImage(url) {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.addEventListener('load', () => {
				resolve(image);
			});
			image.addEventListener('error', reject);
			image.src = url;
		});
	}

	const getImages = () => {
		let silkyObj = generate(mothSilky)

		const { baseSrc, lineSrc, shadeSrc, base, markings } = silkyObj
		const images = [{ src: baseSrc, color: base.color.base, name: 'base' }, { src: shadeSrc, color: base.color.line, name:'shade' }]
		markings.forEach(marking => {
			if (marking.type.base) {
				images.push({
					src: marking.type.baseSrc,
					color: marking.color.base,
					name: marking.type.name
				})
			}
			if (marking.type.shade) {
				images.push({
					src: marking.type.shadeSrc,
					color: marking.color.line,
					name: 'line'
				})
			}
		})
		images.push({ src: lineSrc, color: '#17122D', name: 'line' })
		console.log(images)
		return images
	}

	const drawImages = async (ctx, ctx2, canvas2) => {
		const images = getImages()
		for (let i in images) {
			if (images[i] !== '') {
				ctx2.setTransform(1, 0, 0, 1, 0, 0);
				ctx2.clearRect(0, 0, 564, 502);
				const src = images[i].src;
				const color = images[i].color;
				try {
					let image = await loadImage(src);

					ctx2.fillStyle = color;
					ctx2.fillRect(0, 0, image.width, image.height);
					// clip
					ctx2.globalCompositeOperation = 'destination-in';
					ctx2.drawImage(image, 0, 0, image.width, image.height);
					// reset comp. mode to default
					ctx2.globalCompositeOperation = 'source-over';
					ctx.drawImage(canvasRef2.current, 0, 0, 200, 200);
					// reset comp. mode to default
				} catch (error) {
					console.log(`error loading ${images[i]}`);
				}
			}
		}
	};

	return (
		<Fragment>
			<div className=''>
				<canvas className='' ref={canvasRef} width={200} height={200}></canvas>
				<canvas
					className='hidden'
					ref={canvasRef2}
					width={200}
					height={200}
				></canvas>
			</div>
		</Fragment>
	);
};

export default Canvas;
